import { render, staticRenderFns } from "./RegroupementsDeTravail.vue?vue&type=template&id=1f0b2a35"
import script from "./RegroupementsDeTravail.vue?vue&type=script&lang=js"
export * from "./RegroupementsDeTravail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports